import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'unity-alert',
  templateUrl: './unity-alert.component.html',
  styleUrls: ['./unity-alert.component.scss']
})
export class UnityAlertComponent implements OnInit {
  @Input() type = '';
  @Input() customIcon = null;
  @Input() style = null;
  @Input() noIcon = false;
  constructor() {}

  ngOnInit(): void {}

  getAlertIcon() {
    if (this.type) {
      switch (this.type.toUpperCase()) {
        case 'SUCCESS':
          return 'unity-icon-checkmark-circle-fill';
        case 'INFO':
          return 'unity-icon-information-fill';
        case 'DANGER':
          return 'unity-icon-error-fill';
        case 'WARNING':
          return 'unity-icon-warning-fill';
        default:
          break;
      }
    }
  }
}
